import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAppStore = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.105 2a4.47 4.47 0 0 1-1.023 3.206 3.77 3.77 0 0 1-2.973 1.406 4.26 4.26 0 0 1 1.05-3.088A4.55 4.55 0 0 1 16.105 2M18.182 10.451a4.55 4.55 0 0 0-.591 2.185 4.39 4.39 0 0 0 2.68 4.04 10 10 0 0 1-1.394 2.84c-.821 1.23-1.683 2.43-3.05 2.452-.65.015-1.089-.172-1.546-.367-.477-.203-.974-.415-1.752-.415-.825 0-1.344.219-1.845.43-.433.182-.852.358-1.442.383-1.302.048-2.297-1.312-3.148-2.529-1.702-2.486-3.027-7.006-1.25-10.08a4.88 4.88 0 0 1 4.108-2.506c.738-.015 1.447.27 2.068.519.475.19.899.36 1.246.36.305 0 .717-.163 1.197-.353.757-.3 1.683-.668 2.626-.57a4.65 4.65 0 0 1 3.666 1.983 4.55 4.55 0 0 0-1.573 1.628"
      />
    </svg>
  );
};
export default SvgAppStore;
